import { CurationPostsParams } from '@/types/curation';
import { CurationFiltersUtils as CurationFilters } from '@/types/filter';

export type { CurationFiltersUtils as CurationFilters } from '@/types/filter';

export const buildCurationParams = (
  filters: CurationFilters & { offset?: number; limit?: number; date_range?: 'TODAY' | 'WEEK' | 'MONTH' }
): CurationPostsParams => {
  const params: CurationPostsParams = {}
  
  const stringFieldsToReplace = ['territories', 'contexts', 'topics', 'partners', 'sources']
  const specialMappings: Record<string, string> = {
    search: 'q',
    period: 'date_range'
  }

  for (const [key, value] of Object.entries(filters)) {
    if (value === undefined || value === null) continue

    const paramKey = specialMappings[key] || key

    if (key === 'period' && value !== 'ALL' && value !== '') {
      params.date_range = value as 'TODAY' | 'WEEK' | 'MONTH'
    } else if (stringFieldsToReplace.includes(key) && typeof value === 'string') {
      params[paramKey as keyof CurationPostsParams] = value.replace(/;/g, ',') as any
    } else if (key === 'favorited') {
      if (typeof value === 'boolean') {
        params.favorited = value
      }
    } else if (key === 'offset' || key === 'limit' || key === 'date_range' || key === 'created_by') {
      params[paramKey as keyof CurationPostsParams] = value as any
    } else if (key === 'search' && typeof value === 'string' && value.length > 0) {
      params.q = value
    } else if (typeof value === 'string' && value.length > 0) {
      params[paramKey as keyof CurationPostsParams] = value as any
    }
  }

  return params
}

